import { InvoicesService } from "../../services/invoices.service";
import { Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import { IFormInvoices, field } from "../invoices.model";
import { ITablesExhibitions } from "../../../exhibitions/tables/tables-exhibitions.model";
import { TablesInvoicesService } from "../../services/tables-invoices.service";
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER, TAB } from "@angular/cdk/keycodes";
import { currenciesForSelect } from "../../../../data/currency-codes";

// fields options for select
const OPTIONS_FORM_TYPES = {
  select_table: "select_table",
  autocomplete: "autocomplete",
  photo_checkbox: "photo_checkbox",
  select: "select",
  select_checkbox: "select_checkbox",
  text: "text",
  integer: "integer",
  decimal: "decimal",
  currency: "currency",
  date: "date",
  camera: "camera",
  file: "file",
  hidden: "hidden",
};

//label for field type
const LABEL_FIELD_TYPES = {
  table: "Tabla",
  image_source: "Source Image",
  source: "Source",
  source_field: "Source Field",
  source_col: "Source Col",
  value_col: "Valor Col",
  value_field: "Valor del campo",
  camera_config: "Configuracion camara",
  file_config: "Configuracion Archivo",
  currency_code: "Código de moneda",
};

// types fields enable for relations ( select with others fields ).
const FIELD_TYPES = {
  table: "table",
  image_source: "image_source",
  source: "source",
  source_field: "source_field",
  source_col: "source_col",
  value_col: "value_col",
  min: "min",
  max: "max",
  value_field: "value_field",
  camera_config: "camera_config",
  file_config: "file_config",
  options: "options",
  currency_code: "currency_code",
};

//relations de fields with other field required
const relations = {
  select_table: [FIELD_TYPES.table, FIELD_TYPES.source_col],
  autocomplete: [FIELD_TYPES.table, FIELD_TYPES.source_col],
  photo_checkbox: [
    FIELD_TYPES.table,
    FIELD_TYPES.source,
    FIELD_TYPES.source_col,
    FIELD_TYPES.source_field,
    FIELD_TYPES.value_col,
    FIELD_TYPES.image_source,
  ],
  select: [FIELD_TYPES.options],
  select_checkbox: [FIELD_TYPES.table],
  text: [],
  integer: [],
  decimal: [],
  currency: [FIELD_TYPES.currency_code],
  date: [],
  hidden: [FIELD_TYPES.value_field],
  camera: [FIELD_TYPES.camera_config],
  file: [FIELD_TYPES.file_config],
};

const REQUIRED_FIELD_NAMES = ["id", "id_emisor", "total", "date"];

const CURRENCY_CODE_REGEX = /^[A-Z]{3}$/;

const ERROR_CODES = {
  INVALID_FORM: "Formulario Invalido",
};
@Component({
  selector: "app-form-invoices",
  templateUrl: "./form-invoices.component.html",
  styleUrl: "./form-invoices.component.scss",
})
export class FormInvoicesComponent implements OnInit {
  loading;
  currentId: string;
  mode: "create" | "edit" = "create";
  appId: string;
  dataForm: IFormInvoices;
  OPTIONS_FORM_TYPES_CODES = Object.keys(OPTIONS_FORM_TYPES);
  OPTIONS_FORM_TYPES = OPTIONS_FORM_TYPES;
  LABEL_FIELD_TYPES_CODES = LABEL_FIELD_TYPES;
  fieldTypes = FIELD_TYPES;
  tables: ITablesExhibitions[];
  uriSeparatorKeyCodes = [ENTER, COMMA, TAB];
  currencies = currenciesForSelect;
  constructor(
    private route: ActivatedRoute,
    private invoicesService: InvoicesService,
    private router: Router,
    private tablesService: TablesInvoicesService
  ) {}

  ngOnInit(): void {
    this.appId = this.route.snapshot.paramMap.get("appId");
    const id = this.route.snapshot.paramMap.get("id");
    this.currentId = id;
    if (id && this.appId) {
      this.getForm(id);
    }
    this.getTables();
  }

  async getTables() {
    try {
      if (this.appId) {
        this.tables = (
          await this.tablesService.getTables(this.appId).toPromise()
        ).data;
      }
    } catch (error) {
      console.error("getTables error: ", error);
    }
  }

  addField() {
    const newField: field = {
      type: "text",
      name: "",
      value_field: "",
      label_field: "",
      validations: {
        required: false,
      },
      file_config: {},
      camera_config: {},
    };
    this.dataForm?.fields?.push(newField);
  }

  validateOptionEnable(type, options) {
    return (relations[type] as Array<string>).includes(options);
  }

  removeField(index, field) {
    this.dataForm.fields.splice(index, 1);
  }

  async getForm(id) {
    try {
      const data = await this.invoicesService
        .getForm(this.appId, id)
        .toPromise();
      const dataRefactor = { ...data };
      dataRefactor.fields = { ...data }.fields.map((element) => {
        element.file_config = element.file_config || {};
        element.camera_config = element.camera_config || {};
        if (REQUIRED_FIELD_NAMES.includes(element.name)) {
          element.validations.required = true;
          element.locked = true;
        }
        return element;
      });
      if (!dataRefactor.products_config) {
        dataRefactor.products_config = this.defaultProductsConfig();
      }
      this.dataForm = dataRefactor;
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        if (error.error.code == "NOT_FOUND") {
          this.dataForm = {
            fields: [],
            add_products_section: false,
            products_config: this.defaultProductsConfig(),
          };
        }
      }
      console.error("Error en consulta de Form: ", error);
    }
  }

  defaultProductsConfig(): field {
    return {
      type: "select_table",
      name: "products",
      has_source: false,
      label_field: "",
      value_field: "",
      rename_label_product: "Producto",
      rename_label_qty: "Cantidad",
      rename_label_price: "Precio",
      table: "",
      validations: { required: false },
      file_config: {},
      camera_config: {},
    };
  }

  goToList() {
    this.router.navigate(["pages", "invoices", "forms"]);
  }

  async OKClicked() {
    const valid = await this.validateFields();
    if (!valid) {
      return;
    }
    const dataToSend = JSON.parse(JSON.stringify(this.dataForm));
    dataToSend.fields = dataToSend.fields.map((field) => {
      if (REQUIRED_FIELD_NAMES.includes(field.name)) {
        field.validations.required = true;
      }
      if (field.type !== OPTIONS_FORM_TYPES.currency) {
        delete field.currency_code;
      }
      return field;
    });
    if (!dataToSend.add_products_section) {
      delete dataToSend.products_config;
    } else if (dataToSend.products_config) {
      if (!dataToSend.products_config.has_source) {
        dataToSend.products_config.table = "";
        dataToSend.products_config.label_field = "";
        dataToSend.products_config.value_field = "";
      }
    }
    try {
      const created = await this.invoicesService
        .putForm(dataToSend, this.appId)
        .toPromise();
      if (created) {
        const text =
          this.mode == "create"
            ? "Creado correctamente"
            : "Editado Correctamente";
        Swal.fire("", text, "success");
        this.goToList();
      }
    } catch (error) {
      this.handlerError(error);
    }
  }

  handlerError(error: HttpErrorResponse) {
    console.error("error: ", error.error);

    Swal.fire(
      ERROR_CODES[error.error.code] || "",
      error.error.message,
      "error"
    );
  }

  async validateFields(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.dataForm.add_products_section && this.dataForm.products_config) {
        const prod = this.dataForm.products_config;

        if (
          !prod.rename_label_product ||
          !prod.rename_label_qty ||
          !prod.rename_label_price
        ) {
          Swal.fire(
            "Información Requerida",
            "Los nombres para Producto, Cantidad y Precio son obligatorios.",
            "warning"
          );
          resolve(false);
          return;
        }

        if (prod.has_source) {
          if (!prod.table || !prod.label_field || !prod.value_field) {
            Swal.fire(
              "Fuente de datos incompleta",
              "Al activar 'Cargar datos desde una tabla', debe completar la Tabla, el Título y el Valor.",
              "warning"
            );
            resolve(false);
            return;
          }
        }
      }

      this.dataForm.fields.forEach((element, index) => {
        const fieldTypeRelation = relations[element.type];
        fieldTypeRelation.forEach((fieldsRelation) => {
          const fieldValue = element[fieldsRelation];

          if (fieldValue) {
            if (typeof fieldValue == "object") {
              const objectKeys = Object.keys(fieldValue);
              if (!objectKeys.length) {
                Swal.fire(
                  "",
                  `El campo ${index + 1} en la propiedad '${
                    this.LABEL_FIELD_TYPES_CODES[fieldsRelation] ||
                    fieldsRelation
                  }' no tiene informacion y esta es requerida`,
                  "info"
                );
                resolve(false);
              }
              objectKeys.forEach((data, indexKeys) => {
                if (!fieldValue[data]) {
                  Swal.fire(
                    "",
                    `El campo ${index + 1} en la propiedad '${
                      this.LABEL_FIELD_TYPES_CODES[fieldsRelation] ||
                      fieldsRelation
                    }' en el valor '${
                      objectKeys[indexKeys]
                    }' no tiene informacion y esta es requerida`,
                    "info"
                  );
                  resolve(false);
                }
              });
            }
          } else {
            console.error("field without value: ", element);
            Swal.fire(
              "",
              `El campo ${index + 1} en la propiedad '${
                this.LABEL_FIELD_TYPES_CODES[fieldsRelation] || fieldsRelation
              }' no tiene informacion y esta es requerida`,
              "info"
            );
            resolve(false);
          }
        });
        if (
          element.type === OPTIONS_FORM_TYPES.currency &&
          element.currency_code &&
          !CURRENCY_CODE_REGEX.test(element.currency_code)
        ) {
          Swal.fire(
            "",
            `El campo ${index + 1} en la propiedad '${
              this.LABEL_FIELD_TYPES_CODES.currency_code
            }' debe ser un código de 3 letras mayúsculas (ej: COP, USD)`,
            "info"
          );
          resolve(false);
        }
      });
      return resolve(true);
    });
  }

  getOptionsByType(fieldName: string): string[] {
    if (fieldName === "photos") {
      return [this.OPTIONS_FORM_TYPES.camera];
    }

    return this.OPTIONS_FORM_TYPES_CODES;
  }

  addFieldEnumItem(event: MatChipInputEvent, field) {
    const value = event.value.trim();
    const input = event.chipInput.inputElement;

    if (value && input) {
      if (!field.options) field.options = [];

      field.options.push(value);
      input.value = "";
    }
  }

  onFieldNameChange(field: any) {
    if (REQUIRED_FIELD_NAMES.includes(field.name)) {
      field.validations.required = true;
    }
  }
}
